import { getChartSVG } from './chart-svg';
import { nanoid } from 'nanoid';
import { sanitizeSvgString } from './svg';

const HEADER = 'data:image/svg+xml;base64,';

export type ChartOptionsToBase64SvgOptions = {
  chartOptions: Highcharts.Options;
  width: number;
  height: number;
};

export const chartOptionsToBase64Svg = (
  options: ChartOptionsToBase64SvgOptions
): string => {
  const chartOptions: Highcharts.Options = {
    ...options.chartOptions,
    chart: {
      ...options.chartOptions.chart,
      backgroundColor: 'transparent',
    },
  };

  return [
    HEADER,
    btoa(
      sanitizeSvgString(
        getChartSVG(
          nanoid(),
          chartOptions,
          `width: ${options.width}px; height: ${options.height}px`
        )
      )
    ),
  ].join('');
};
